export const SELECT_MODE = {
  ALL: 'all',
  SELECTED: 'selected',
}
